// Chat round six (M64, docs/chat-round-six.md): pinned chats (D237),
// disappearing messages (D238) and scheduled messages (D239). Shared rules
// and payloads, used by the server and the apps.
import { SCHEDULE_LIMITS } from './constants.js';
const time = (value) => value ? new Date(value).getTime() : 0;
/**
 * The home's order (D237): "Everyone" first (D10), then pinned chats in the
 * order they were pinned, then the rest, newest message first.
 */
export function compareHome(a, b) {
    if (a.isDefault !== b.isDefault)
        return a.isDefault ? -1 : 1;
    const aPinned = Boolean(a.pinnedAt);
    const bPinned = Boolean(b.pinnedAt);
    if (aPinned !== bPinned)
        return aPinned ? -1 : 1;
    if (aPinned && bPinned)
        return time(a.pinnedAt) - time(b.pinnedAt);
    return time(b.lastMessageAt) - time(a.lastMessageAt);
}
export function sortHome(list) {
    return [...list].sort(compareHome);
}
/** Whether a disappearing message's time is up (D238). */
export function isExpired(expiresAt, now = Date.now()) {
    return Boolean(expiresAt) && time(expiresAt) <= now;
}
/**
 * Why a send-later time can't be used (D239): at least 5 minutes and at
 * most 30 days ahead, with a minute's grace for the trip.
 */
export function scheduleTimeProblem(scheduledFor, now = Date.now()) {
    const at = time(scheduledFor);
    if (!Number.isFinite(at) || at === 0)
        return 'invalid';
    if (at < now + SCHEDULE_LIMITS.MIN_LEAD_MS - SCHEDULE_LIMITS.GRACE_MS) {
        return 'too_soon';
    }
    if (at > now + SCHEDULE_LIMITS.MAX_LEAD_MS + SCHEDULE_LIMITS.GRACE_MS) {
        return 'too_far';
    }
    return null;
}
//# sourceMappingURL=chatRoundSix.js.map